import React, { useState } from "react";
import "../style/contact.scss";

export default function Contact() {
  const [loading, setLoading] = useState(false);
  const [formSent, setFormSent] = useState(false);
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");

  const handleInputChange = (e, setValue) => {
    setValue(e.target.value);
  };

  const submitForm = async (e) => {
    e.preventDefault();

    const emailTemplate = `
      <html>
          <head>
          <style>
            body {
              font-family: Arial, sans-serif;
              color: #333333;
            }

            * {
              box-sizing: border-box;
            }

            .container {
              width: 100%;
              max-width: 600px;
              margin: 0 auto;
              padding: 20px;
              background-color: #f7f7f7;
            }

            p {
              font-size: 16px;
              margin-top: 0;

            }
            b {
              font-size: 16px;
            }

            a {
              color: #167ade;
              text-decoration: underline;
            }

    
            .section {
              margin-bottom: 40px;
              margin-top: 20px;
            }

            .header {
              background-color: #ffffff;
              padding: 20px;
              text-align: center;
              display: flex;
              justify-content: space-between;
            }

            .header ul {
              padding-inline-start: 0;
            }

            .header ul li {
              list-style: none;
              text-align: start;
            }

            .logo {
              width: 30%;
            }

            @media only screen and (max-width: 600px) {
              .container {
                padding: 10px;
                width: 100%;
              }
            }
      
            .works img {
              width: 100%;
              border-radius: 20px;
            }
            .works a {
              background: #ecdbc1;
              padding: 10px;
              color: #000;
              display: inline-block;
              text-decoration: none;
              text-align: center;
              border-radius: 20px;
              margin-top: 20px;
              width: 100%;
            }

          </style>
          </head>

            <div class="container">
            <div class="header">
              <img src='https://www.helibrows.rs/static/media/helibrowsLogo.736f377fbd1d27d774ef4012b634eca4.svg' alt="Heli Brows Logo" class="logo">
              <ul>
                <li>Email:   <a href="mailto:info@helibrows.rs" target="_blank">info@helibrows.rs</a></li>
                <li>Lokacija: <a href="https://maps.app.goo.gl/Kor3ofX7zhW129PV8" target="_blank">Beograd</a></li>
              </ul>
            </div>

          
            <div class="section">
              <b>Ime i prezime:</b> <p>${fullName}</p>
              <b>Email:</b> <p>${email}</p>
              <b>Broj telefona:</b> <p>${phone}</p>
              <b>Poruka:</b> <p>${message}</p>
            </div>

            <div class="works">
              <img src="./img4.png" alt="">
            </div>

          </div>
        </html>
    `;

    try {
      await fetch("/contact.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: fullName,
          email: email,
          phone: phone,
          message: emailTemplate,
        }),
      });

      setLoading(true);
      setTimeout(() => {
        setLoading(false);
        setFormSent(true);
        setTimeout(() => {
          setFormSent(false);

          setTimeout(() => {
            window.location.reload();
          });
        }, 3000);
      }, 3000);
    } catch (e) {
      console.error(e);
      setLoading(false);
    }
  };

  return (
    <>
      <div
        style={{ borderRadius: "0 0 30px 30px" }}
        className="container banner"
      >
        <div className="wrapper p-30 title-box">
          <h1 className="title">Kontaktirajte me</h1>
          <h2 className="subtitle">
            Vaš put do savršenih <br /> obrva počinje ovde
          </h2>
        </div>
      </div>

      <div className="wrapper p-30">
        <form className="form" method="post" onSubmit={submitForm}>
          <label htmlFor="">Ime i Prezime *</label>
          <input
            required
            type="text"
            id="fullName"
            onChange={(e) => handleInputChange(e, setFullName)}
          />

          <label htmlFor="">Email adresa *</label>
          <input
            id="email"
            required
            type="email"
            onChange={(e) => handleInputChange(e, setEmail)}
          />

          <label htmlFor="">Broj telefon *</label>
          <input
            id="phone"
            required
            type="text"
            onChange={(e) => handleInputChange(e, setPhone)}
          />

          <label htmlFor="">Poruka *</label>
          <textarea
            onChange={(e) => handleInputChange(e, setMessage)}
            required
            id="message"
          />

          <div
            className="send-message"
            style={{ display: formSent ? "block" : "none" }}
          >
            HVALA VAM! PORUKA JE UPRAVO POSLATA.
          </div>

          <button type="submit" disabled={loading}>
            {loading ? "Poruka se šalje... " : "Pošalji poruku"}
            {loading && (
              <div className="lds-ring">
                <div />
                <div />
                <div />
                <div />
              </div>
            )}
          </button>
        </form>
      </div>
    </>
  );
}
